// Global reference to the Bubble instance
let bubbleInstance = null;

export function setBubbleInstance(instance) {
  bubbleInstance = instance;
}

export function bubbleEvent(event, callback = () => {}) {
  if (bubbleInstance && typeof window !== "undefined" && window.localStorage) {
    bubbleInstance.triggerEvent(event, callback);
  }
}

export function bubbleState(state, value) {
  //If value is an array, stringify each item in the array
  if (Array.isArray(value)) {
    value = value.map((item) => JSON.stringify(item));
  }

  //If value is an object and not an array, stringify the object
  if (typeof value === "object" && !Array.isArray(value)) {
    value = JSON.stringify(value);
  }

  if (bubbleInstance && typeof window !== "undefined" && window.localStorage) {
    bubbleInstance.publishState(state, value);
  }
}
